import { Route, Routes, Outlet, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import LoginPage from "./pages/Login";
import ConfirmationPage from "./pages/ConfirmationPage";
import TicketInfoPage from "./pages/TicketInfoPage";
import SuccessPage from "./pages/SuccessPage";
import FailedPage from "./pages/FailedPage";
import ChooseUserPage from "./pages/ChooseUser";
import PrintTicketPage from "./pages/PrintTicket";
import AuthProvider, { useAuth } from "./providers/AuthProvider";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import NotFound from "./pages/NotFound";
import ErrorPage from "./pages/ErrorPage";
import StatTicketPage from "./pages/StatTicketPage";
import TransferEventsPage from "./pages/TransferEvents";
import ChooseMinor from "./pages/digitalAccess/ChooseMinor";
import ChooseActionPage from "./pages/digitalAccess/ChooseAction";
import CancelEventsPage from "./pages/digitalAccess/CancelEvents";
import ChosenMinorPage from "./pages/digitalAccess/ChosenMinor";

const PrivateRoutes = ({ roles }) => {
  const { isAuth, authUser } = useAuth();
  if (isAuth) {
    return roles.includes(authUser.TICKET_ROLE) ? (
      <Outlet />
    ) : (
      <Navigate to="/tickets/error" />
    );
  } else {
    return <Navigate to="/" />;
  }
};

function App() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <AuthProvider>
        <Routes>
          <Route path="/tickets/*">
            <Route index element={<Home />} />
            <Route path="login-app" element={<LoginPage />} />
            <Route path="error" element={<ErrorPage />} />
            <Route
              element={<PrivateRoutes roles={["STANDARD_USER", "OFFICER"]} />}
            >
              <Route path="confirmation" element={<ConfirmationPage />} />
              <Route path="choose-action" element={<ChooseActionPage />} />
              <Route path="choose-minor" element={<ChooseMinor />} />
              <Route path="cancel-events" element={<CancelEventsPage />} />
              <Route path="selected-minor" element={<ChosenMinorPage />} />
              <Route path="success-companion" element={<SuccessPage />} />
              <Route path="success-cancel" element={<SuccessPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/ticket-office/*">
            <Route index element={<Home />} />
            <Route path="login-app" element={<LoginPage />} />
            <Route element={<PrivateRoutes roles={["OFFICER"]} />}>
              <Route path="confirmation" element={<ConfirmationPage />} />
              <Route path="choose-user" element={<ChooseUserPage />} />
              <Route path="ticket-info" element={<TicketInfoPage />} />
              <Route path="success" element={<SuccessPage />} />
              <Route path="failed" element={<FailedPage />} />
              <Route path="print-ticket" element={<PrintTicketPage />} />
              <Route path="stats/ticket" element={<StatTicketPage />} />
              <Route path="transfer-events" element={<TransferEventsPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/" element={<Navigate to="/tickets" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ToastContainer theme="colored" />
      </AuthProvider>
    </div>
  );
}

export default App;
